import { LogoutOptions } from '@auth0/auth0-react';
import axios from 'axios';
import Qs from 'qs';

const GET_TIMEOUT = 30000;

export const BASE_URL = '/api';

const paramsSerializer = (params: any) =>
  Qs.stringify(params, { arrayFormat: 'repeat', allowDots: true });

let getAccessToken: () => Promise<string>;
let auth0Logout: (options?: LogoutOptions) => Promise<void>;

export const setAccessTokenGetter = (
  getAccessTokenFn: () => Promise<string>
) => {
  getAccessToken = getAccessTokenFn;
};

export const setAuth0Logout = (
  logoutFn: (options?: LogoutOptions) => Promise<void>
) => {
  auth0Logout = logoutFn;
};

const apiFactory = () => {
  const api = axios.create({
    baseURL: BASE_URL,
    timeout: GET_TIMEOUT,
    paramsSerializer,
    transitional: {
      clarifyTimeoutError: true,
    },
  });

  api.interceptors.request.use(
    async (config) => {
      if (config.method?.toLocaleLowerCase() === 'get') {
        config.headers.Accept = 'application/json';
      }

      if (config.url !== 'enrollment/signup') {
        try {
          const token = await getAccessToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        } catch (error) {
          console.error('Error fetching Auth0 token:', error);
          auth0Logout({ logoutParams: { returnTo: window.location.origin } });
        }
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  return api;
};

const api = apiFactory();
export default api;
